import CardFooter from './CardFooter';
export default CardFooter;